<template>
  <div class="d-flex d-row justify-content-start align-items-start">
    <div class="col side-bar">
      <div
        class="d-flex flex-column flex-shrink-0 p-3 pt-0 justify-content-start align-items-start"
      >
        <div class="accordion">
          <div class="accordion-item">
            <h2>
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseOne"
                aria-expanded="true"
                aria-controls="panelsStayOpen-collapseOne"
              >
                Delivery Zones
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseOne"
              class="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-headingOne"
            >
              <div class="accordion-body">
                <ul class="nav nav-pills flex-column mb-auto">
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-zones"
                    >
                      Delivery Zones
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-zone-countries"
                    >
                      Zones &lt;have> Countries
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-zone-postcodes"
                    >
                      Countries &lt;have> Postcodes
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2>
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseTwo"
                aria-expanded="true"
                aria-controls="panelsStayOpen-collapseTwo"
              >
                Delivery Methods
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseTwo"
              class="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-headingTwo"
            >
              <div class="accordion-body">
                <ul class="nav nav-pills flex-column mb-auto">
                  <li class="nav-item text-left">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-options"
                    >
                      Delivery Methods
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-dimensions"
                    >
                      Dimensions
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-price-lists"
                    >
                      Price Lists
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-prices"
                    >
                      Prices
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-dimension-zones"
                    >
                      Zones &lt;have> Dimensions
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/delivery/config/delivery-time-ranges"
                    >
                      Time Ranges
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2>
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseThree"
                aria-expanded="true"
                aria-controls="panelsStayOpen-collapseThree"
              >
                Delivery Tools
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseThree"
              class="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-headingTwo"
            >
              <div class="accordion-body">
                <ul class="nav nav-pills flex-column mb-auto">
                  <li class="nav-item">
                    <router-link class="nav-link" to="/delivery/test">
                      Delivery Test
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <img href="assets/delivery_schema.png" />
      </div>
    </div>
    <div class="col">
      <router-view />
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.side-bar
  width 350px
  flex 0 0 350px
.col
  text-align left
</style>
